import { render, staticRenderFns } from "./AIAvatarBackgroundSelectionButton.vue?vue&type=template&id=d7c21c5c&scoped=true"
import script from "./AIAvatarBackgroundSelectionButton.vue?vue&type=script&lang=ts"
export * from "./AIAvatarBackgroundSelectionButton.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarBackgroundSelectionButton.vue?vue&type=style&index=0&id=d7c21c5c&prod&lang=scss"
import style1 from "./AIAvatarBackgroundSelectionButton.vue?vue&type=style&index=1&id=d7c21c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c21c5c",
  null
  
)

export default component.exports